import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
// used for testing fetch calls that expect a
// promise returned by jsonify

export function jsoniblePromise(resolutionValue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var resolvePromise = new Promise(function (resolve, reject) {
    resolve(resolutionValue);
  });
  return {
    status: options.status || 200,
    headers: {
      get: function get(attr) {
        return _objectSpread({
          'Content-Type': options.contentType || 'application/json; charset=utf-8'
        }, options.headers || {})[attr];
      }
    },
    json: function json() {
      return resolvePromise;
    }
  };
}
export default (function (res) {
  return res.json();
});